// Utility to send error data to the remote endpoint
export async function reportErrorToEndpoint({ error_message, id, itinerary_id, itinerary_json, endpoint, user_data }) {
  const errorPayload = {
    error_message: error_message || "Unknown error",
    id: id || "unknown-id",
    itinerary_id: itinerary_id || "",
    itinerary_json: itinerary_json || {},
    endpoint: endpoint || "",
    user_data: user_data || {},
    error_timestamp: new Date().toUTCString()
  };

  // Print the request body to the console
  // console.log("[Error Reporter] Request body for https://search-accomodation-14140141147.us-central1.run.app:", errorPayload);

  try {
    await fetch("", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(errorPayload)
    });
  } catch (err) {
    // Optionally log to local storage or another fallback
    console.error("Failed to report error:", err);
  }
}
